/*
 * GA4 Inline Event Tracking
 * Extracted from theme.liquid for caching and reduced inline script evaluation.
 * Events: begin_checkout, select_item, remove_from_cart, newsletter sign_up
 *
 * Requires window.__deferAnalyticsInit and window.__shopCurrency to be set
 * before this script runs.
 */

(function () {
  'use strict';

  var currency = window.__shopCurrency || 'SAR';

  /* ---- begin_checkout ---- */
  window.__deferAnalyticsInit(function () {
    document.addEventListener('click', function (e) {
      var checkoutButton = e.target.closest(
        '[name="checkout"], .cart__checkout-button, .checkout-button, [href*="/checkout"]'
      );

      if (!checkoutButton) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items.map(function (item, index) {
            return {
              item_id: item.product_id.toString(),
              item_name: item.product_title,
              item_brand: item.vendor || '',
              item_category: item.product_type || '',
              item_variant: item.variant_id.toString(),
              price: (item.final_price / 100).toFixed(2),
              currency: cart.currency,
              quantity: item.quantity,
              index: index,
              discount:
                item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0
                  ? (item.line_level_discount_allocations.reduce(function (sum, d) { return sum + d.amount; }, 0) / 100).toFixed(2)
                  : 0,
              coupon: ''
            };
          });

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
              currency: cart.currency,
              value: (cart.total_price / 100).toFixed(2),
              items: items
            }
          });
        });
    });
  });

  /* ---- select_item ---- */
  window.__deferAnalyticsInit(function () {
    document.addEventListener('click', function (e) {
      var productCard = e.target.closest('.product-card, .card, .grid__item, [data-product-card]');
      var productLink = e.target.closest('a[href*="/products/"]');

      if (!(productCard && productLink)) return;

      requestAnimationFrame(function () {
        setTimeout(function () {
          var itemName = (productCard.querySelector('.card__heading, .product-card__title, .product-title, h3, h2') || {}).textContent;
          itemName = itemName ? itemName.trim() : '';
          var priceEl = productCard.querySelector('.price-item, .price, .product-price');
          var price = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) : 0;
          var listName = (document.querySelector('.collection__title, h1') || {}).textContent;
          listName = listName ? listName.trim() : 'Product List';
          var productId = (productLink.href.match(/\/products\/([^?\/]+)/) || [])[1] || '';
          var vendor = (productCard.querySelector('.card__vendor, .product-vendor') || {}).textContent;
          vendor = vendor ? vendor.trim() : '';
          var productType = (productCard.querySelector('.card__type, .product-type') || {}).textContent;
          productType = productType ? productType.trim() : '';
          var index = Array.from(productCard.parentElement.children).indexOf(productCard);

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'select_item',
            ecommerce: {
              item_list_name: listName,
              items: [{
                item_id: productId,
                item_name: itemName,
                item_brand: vendor,
                item_category: productType,
                item_list_name: listName,
                item_variant: '',
                price: price,
                currency: currency,
                quantity: 1,
                index: index,
                discount: 0,
                coupon: ''
              }]
            }
          });
        }, 0);
      });
    });
  });

  /* ---- remove_from_cart ---- */
  window.__deferAnalyticsInit(function () {
    document.addEventListener('click', function (e) {
      var removeButton = e.target.closest('cart-remove-button, .cart-remove, [href*="/cart/change?line="]');
      if (!removeButton) return;

      var cartItem = removeButton.closest('tr[class*="cart-item"]');
      if (!cartItem) return;

      requestAnimationFrame(function () {
        setTimeout(function () {
          var productLink = cartItem.querySelector('a.cart-items__title, a[href*="/products/"]');
          var itemName = productLink ? productLink.textContent.trim() : '';
          var productId = productLink && productLink.href ? (productLink.href.match(/\/products\/([^?\/]+)/) || [])[1] || '' : '';
          var vendorEl = cartItem.querySelector('.cart-items__vendor, [class*="vendor"]');
          var vendor = vendorEl ? vendorEl.textContent.trim() : '';
          var typeEl = cartItem.querySelector('.cart-items__type, [class*="type"]');
          var productType = typeEl ? typeEl.textContent.trim() : '';
          var priceEl = cartItem.querySelector('.cart-items__price, [class*="price"]');
          var priceText = priceEl ? priceEl.textContent : '0';
          var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
          var qtyInput = cartItem.querySelector('input[name*="updates"], .cart-items__quantity input');
          var quantity = qtyInput ? parseInt(qtyInput.value) : 1;
          var variantId = cartItem.getAttribute('data-variant-id') || '';

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
              currency: currency,
              value: (price * quantity).toFixed(2),
              items: [{
                item_id: productId,
                item_name: itemName,
                item_brand: vendor,
                item_category: productType,
                item_variant: variantId,
                price: price.toFixed(2),
                currency: currency,
                quantity: quantity,
                index: 0,
                discount: 0,
                coupon: ''
              }]
            }
          });
        }, 0);
      });
    });
  });

  /* ---- newsletter sign_up ---- */
  window.__deferAnalyticsInit(function () {
    var forms = document.querySelectorAll(
      'form[action*="newsletter"], form[action*="/contact"], .newsletter-form, .footer__newsletter'
    );

    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ event: 'sign_up', method: 'newsletter' });
      });
    }
  });
})();
